import { portfolioData } from '../../../mocks/portfolio';

export default function Projects() {
  const { projects } = portfolioData;

  return (
    <section id="projects" className="bg-[#1e1e1e] py-32">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <div className="text-center mb-20">
          <h2 className="text-white text-5xl lg:text-6xl font-bold mb-4">
            主要プロジェクト
          </h2>
          <p className="text-[#b8b8b8] text-xl max-w-3xl mx-auto leading-relaxed">
            これまでに手がけた代表的なプロジェクトをご紹介します。
            それぞれのプロジェクトで、ユーザーのニーズを深く理解し、創造的なソリューションを提供してきました。
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {projects.map((project) => (
            <div
              key={project.id}
              className="bg-[#f8f8f8] rounded-xl overflow-hidden hover:transform hover:-translate-y-2 transition-all duration-300 cursor-pointer shadow-lg hover:shadow-2xl"
              style={{ aspectRatio: '4/5' }}
            >
              {/* Featured Label */}
              {project.featured && (
                <div className="absolute top-4 left-4 z-10">
                  <span className="bg-[#1a1a1a] text-white text-xs px-3 py-1.5 rounded-md font-semibold">
                    Featured
                  </span>
                </div>
              )}

              {/* Image Container */}
              <div className="relative h-3/4 p-5">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>

              {/* Info */}
              <div className="h-1/4 flex flex-col justify-center items-center text-center px-4 pb-4">
                <h3 className="text-[#2a2a2a] text-xl font-bold mb-1">{project.title}</h3>
                <p className="text-[#666666] text-sm">
                  {project.category} • {project.year}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}